import Head from 'expo-router/head';
import { ScrollView } from 'react-native';
import { getTokenValue, YStack } from 'tamagui';

import UpcomingBookingBanner from '@/components/UpcomingBookingBanner';
import PSText from '@/components/ui/PSText';

const PREVIEWS: {
  id: string;
  label: string;
  image: string;
  title: string;
  ticketSlotDisplayLine: string;
}[] = [
  {
    id: 'design',
    label: 'The design reference — title truncates on the second line',
    image: 'https://picsum.photos/id/1060/600/800',
    title:
      'Barre workout by Physique 57 and some big ass title to test truncation',
    ticketSlotDisplayLine: 'Today, at 6 AM',
  },
  {
    id: 'short',
    label: 'Short title — one line, text stays centred on the image',
    image: 'https://picsum.photos/id/1043/600/800',
    title: 'Pottery',
    ticketSlotDisplayLine: 'Tomorrow, at 11 AM',
  },
  {
    id: 'two-lines',
    label: 'Exactly two lines — no ellipsis',
    image: 'https://picsum.photos/id/1015/600/800',
    title: 'Sunset rooftop jazz at The Listening Room',
    ticketSlotDisplayLine: 'Sat, 27 Dec, at 6:30 PM',
  },
  {
    id: 'long-word',
    label: 'One unbroken long word',
    image: 'https://picsum.photos/id/1025/600/800',
    title: 'Supercalifragilisticexpialidociousworkshopextravaganza',
    ticketSlotDisplayLine: 'Today, at 6 AM',
  },
  {
    id: 'long-slot',
    label: 'Long slot line — clamps to one line',
    image: 'https://picsum.photos/id/1080/600/800',
    title: 'Barre workout by Physique 57',
    ticketSlotDisplayLine:
      'Fri, 15 Jan 2027, 11:30 PM – Sat, 16 Jan 2027, 2:00 AM',
  },
  {
    id: 'landscape',
    label: 'Landscape source image — cropped to the 3:4 box',
    image: 'https://picsum.photos/id/1036/1200/600',
    title: 'Barre workout by Physique 57',
    ticketSlotDisplayLine: 'Today, at 6 AM',
  },
  {
    id: 'broken-image',
    label: 'Broken image URL — empty box keeps the layout',
    image: 'https://picsum.photos/id/does-not-exist',
    title: 'Barre workout by Physique 57',
    ticketSlotDisplayLine: 'Today, at 6 AM',
  },
];

function PreviewList({ variant }: { variant: 'light' | 'dark' }) {
  const dark = variant === 'dark';

  return (
    <YStack
      gap="$lg"
      p="$lg"
      bg={dark ? '$color.brandDark' : '$color.background'}
    >
      <PSText.H2 color={dark ? '$textWhite' : '$textDark'}>
        {dark ? 'Dark' : 'Light'}
      </PSText.H2>
      {PREVIEWS.map((preview) => (
        <YStack key={preview.id} gap="$xs">
          <PSText.Body3 color={dark ? '$textWhiteMuted' : '$textDarkMuted'}>
            {preview.label}
          </PSText.Body3>
          <UpcomingBookingBanner
            image={preview.image}
            title={preview.title}
            ticketSlotDisplayLine={preview.ticketSlotDisplayLine}
            variant={variant}
          />
        </YStack>
      ))}
    </YStack>
  );
}

export default function UpcomingBookingBannerPreview() {
  return (
    <>
      <Head>
        <title>UpcomingBookingBanner · Putting Scene</title>
      </Head>
      <ScrollView
        style={{
          flex: 1,
          backgroundColor: getTokenValue('$color.background', 'color'),
        }}
      >
        <PreviewList variant="light" />
        <PreviewList variant="dark" />
      </ScrollView>
    </>
  );
}
